import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BranchDropdownComponent } from './branch-dropdown.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [BranchDropdownComponent],
  exports: [BranchDropdownComponent],
})
export class BranchDropdownModule { }
